<h1 mat-dialog-title>{{'user_profile.title' | localize }}</h1>

<div mat-dialog-content class="user-profile-page">
  <form [formGroup]="userProfileForm" class="d-block">
    <div class="user-profile-wrapper">
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{'user_profile.country' | localize }}</mat-label>
            <input matInput formControlName="country">
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{'user_profile.emailID' | localize }}</mat-label>
            <input matInput formControlName="emailId">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{'user_profile.role' | localize }}</mat-label>
            <input matInput formControlName="userRole">
          </mat-form-field>
        </div>
        <!-- <div class="col-md-6">
          <div class="d-flex" *ngIf="userData?.['roleId'] == 2 || userData?.['roleId'] == 8">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label> {{'user_profile.defaultLoginStatus' | localize }}</mat-label>
              <mat-select formControlName="defaultStatusAfterLogin">
                  <mat-option [value]="0">{{'user_profile.notavailable' | localize }}</mat-option>
                  <mat-option [value]="1">{{'user_profile.available' | localize }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div> -->
      </div>

      <!-- <div class="d-flex agent-video-wrapper">
        <mat-slide-toggle formControlName="agentVideoStream">{{'user_profile.video' | localize }}</mat-slide-toggle>
        <mat-icon class="info-icon"  [matTooltipClass]="'tool-tip'"
        matTooltip="{{'user_profile.videoStreaming' | localize }}"  [matTooltipPosition]="'right'">info</mat-icon>
      </div> -->


      <div class="col-12 d-flex mb-2">
        <mat-radio-group formControlName="employeeType" class="d-flex align-items-center">
          <mat-label class="employee-label-width"> {{'user_profile.type' | localize }}</mat-label>
          <mat-radio-button *ngFor="let eType of employeeType" [value]="eType.id" [disabled]="true"
          [checked]="userData?.['shiftType'] == eType.id">
            {{ "user_profile."+ eType.text | localize }}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="col-12 d-inline-flex align-items-center call-type-wrapper mb-2" *ngIf="userData?.['isAgent'] == 1" formArrayName="callTypes">
        <mat-label> {{'user_profile.calltype' | localize }}</mat-label>
        <section class="d-flex">
          <mat-chip-listbox *ngFor="let callType of callTypes.controls; let i=index" class="mx-1">
            <mat-chip-option *ngIf="callType.value.isDisplay == 1" [disabled]="true"
            [selected]="userCalltypes[i].type === userData?.['callType']">{{"user_profile."+callType.value.type | localize}}</mat-chip-option>
          </mat-chip-listbox>
        </section>
      </div>

      <div class="col-12 d-flex mb-2" formArrayName="languages">
        <mat-label class="language-label-width"> {{'user_profile.languages' | localize }}</mat-label>
        <section class="d-flex flex-wrap">
          <mat-chip-listbox *ngFor="let language of languages.controls" class="mx-1">
            <mat-chip-option [disabled]="true"
            [selected]="userLanguageSkills?.indexOf(language.value.code) > -1">{{("user_profile."+language.value.value | lowercase )| localize}}</mat-chip-option>
          </mat-chip-listbox>
        </section>
      </div>
    </div>
  </form>
</div>
<!-- *ngIf="this.userData.isAgent == 1" -->
<!-- <div class="col-12 d-flex mb-2 volume-adjust align-items-center" >
  <mat-label class="employee-label-width"> {{'volume' | localize }}</mat-label>
  <audio id="ringtoneVolume">
    <source src="../../../../assets/audio/ringtone.mp3" type="audio/mpeg">
  </audio>
  <mat-slider min="0" max="1" step="0.1" discrete [displayWith]="formatLabel">
    <input matSliderThumb matInput formControlName="volume" (change)="adjustVolume()">
  </mat-slider>
</div> -->

<div mat-dialog-actions align="end">
  <button type="submit" id="userProfileSubmitButton" mat-raised-button (click)="submitUserProfileForm()" [disabled]="!userProfileForm.valid" cdkFocusInitial
  color="primary">{{'user_profile.saveChanges' | localize }}</button>
  <button mat-raised-button id="closeButton" class="reset_bg" (click)="onDialogCancel()">{{'close' | localize }}</button>
</div>

